import React from 'react';
import { Link } from 'react-router-dom';
import '../../components/util/generalStyles.css';
import './styles.css';

function Tools() {

    return (
        <div className='generalTools'>
            <div className="container">
                <div className='generalContainer'>
                    <h2>tools</h2>
                    <ul>
                        <li><Link to="/tools/text-editor">editors</Link></li>
                        <li><Link to="/tools/formatter">formatters</Link></li>
                        <li><Link to="/tools/xcoder">x-coders</Link></li>
                        <li><Link to="/tools/generator">generators</Link></li>
                        <li><Link to="/tools/logic">logic</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Tools;